var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_341_15719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00513 4.59576H2.34583C1.89932 4.59576 1.53735 4.95773 1.53735 5.40424V8.23389C1.53735 8.68039 1.89932 9.04236 2.34583 9.04236H8.00513C8.45163 9.04236 8.8136 8.68039 8.8136 8.23389V5.40424C8.8136 4.95773 8.45163 4.59576 8.00513 4.59576Z",
    stroke: "#2FE5A7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1543 4.59576V2.97882C3.1543 2.44277 3.36724 1.92868 3.74629 1.54963C4.12533 1.17059 4.63943 0.957642 5.17548 0.957642C5.71153 0.957642 6.22562 1.17059 6.60467 1.54963C6.98371 1.92868 7.19666 2.44277 7.19666 2.97882V4.59576",
    stroke: "#2FE5A7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_341_15719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.70166,
    height: 9.70166,
    fill: "white",
    transform: "translate(0.324585 0.14917)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.6780d318ff96bc25e8678947be6109b1.svg";
export { ForwardRef as ReactComponent };